// removed by extract-text-webpack-plugin
module.exports = {"Loading":"loading__Loading__1T-QW","SmallLoading":"loading__SmallLoading__1f9v6","Graph":"loading__Graph__3QT1-","Pending":"loading__Pending__1WNJG","dot1":"loading__dot1__28Dg5","visibility":"loading__visibility__2Bq22","dot2":"loading__dot2__cetFu","visibility2":"loading__visibility2__KlGmZ","dot3":"loading__dot3__2os4I","visibility3":"loading__visibility3__26I3n"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Loading/loading.css
// module id = 449
// module chunks = 2